import { TableColumn } from 'lib/components/datatable/DataTable.vue.d';

import { DragableColumn } from '../CustomColumn.vue.d';

/**
 * Updates the `visible` property of each table column based on the `maxColumn` limit
 * and how many columns are currently visible. Only columns with `checkedByDefault !== false`
 * will be considered for visibility.
 *
 * @param column - Array of table column definitions.
 * @param maxColumn - Maximum number of columns that should be visible at once.
 * @param currentVisibleColumnsLength - The current number of columns that are visible.
 */
export const setVisibilityByMaxColumn = (
  column: TableColumn[],
  maxColumn: number,
  currentVisibleColumnsLength: number,
): DragableColumn[] => {
  if (maxColumn && currentVisibleColumnsLength > maxColumn) {
    let visibleColumnsLength = 0;
    return column.map((col) => {
      const spaceAvailable =
        maxColumn !== undefined && visibleColumnsLength < maxColumn;

      const visible =
        (col.checkedByDefault !== false && maxColumn === undefined) ||
        (col.checkedByDefault !== false && spaceAvailable);

      if (visible) visibleColumnsLength++;

      return {
        ...col,
        visible,
      };
    });
  }

  return column;
};
